<script lang="ts">
    import { onMount } from 'svelte'

    import { orderBy } from 'lodash-es'

    import { gettext as _ } from 'hydria/services/gettext'
    import { lg } from 'hydria/services/language'
    import { simpleFetch, groups as ugroups, type SimpleFetchResult } from 'hydria/services/session'
    import { sanchor, spath } from 'hydria/svelte_helpers'
    import { humanizedNumber } from 'hydria/utils/humanized_numbers'

    import Date from 'hydria/components/Date.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    let loading: boolean | undefined = $state()
    let error: string | undefined = $state()
    let zstatus: any = $state()

    async function load() {
        loading = true
        error = undefined
        let r: SimpleFetchResult | undefined
        try {
            r = await simpleFetch('GET', '/json/zone/1/server-statuses')
        } catch (e: any) {
            error = 'Exception'
        }

        if (r && r.data && r.data.items) {
            zstatus = orderBy(r.data.items, [(i) => i['name'], (i) => (i['type'] == 'master' ? 1 : 2)], ['asc', 'asc'])
        }

        loading = false
    }
    onMount(() => {
        if ($ugroups.has('zone-servers') && loading == null) {
            load()
        }
    })
</script>

{#if $ugroups.has('zone-servers')}
    <div class="card">
        <div class="card-title text-primary">{$_('NSD Server Statuses')}</div>
        {#if loading !== false}
            <div class="card-body">
                <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
            </div>
        {:else if error}
            <div class="card-body">Les données n’ont pas pu être chargées.</div>
        {:else}
            <div class="card-body">
                <table class="table mb-0">
                    <tbody>
                        {#each zstatus as item}
                            <tr>
                                <th>{item.name}</th>
                                <td><a use:sanchor href={spath(`/nsd-server/${item.id}/dns`)} data-tooltip="DNS ping">D</a></td>
                                <td class="text-end" class:text-success={item.apdex_dns.apdex_score >= 0.9} class:text-warning={item.apdex_dns.apdex_score >= 0.8 && item.apdex_dns.apdex_score < 0.9} class:text-danger={item.apdex_dns.apdex_score < 0.8}>{(item.apdex_dns.apdex_score * 100).toFixed(2)} %</td>
                                <td class="text-end">
                                    <span class:text-success={item.last_dns_ping_us < item.dns_apdex_thresholds.satisfied_us} class:text-warning={item.last_dns_ping_us >= item.dns_apdex_thresholds.satisfied_us && item.last_dns_ping_us < item.dns_apdex_thresholds.tolerated_us} class:text-danger={item.last_dns_ping_us >= item.dns_apdex_thresholds.tolerated_us}>{humanizedNumber(item.last_dns_ping_us, 2, 1000, ['µs', 'ms', 's'], false, $lg)}</span>
                                    @ <Date value={item.last_dns_contact} format="h-table-s" />
                                </td>
                            </tr>
                            <tr class="tr-group-with-top">
                                <td class="text-center" class:text-success={item.is_online} class:text-danger={!item.is_online}>{item.is_online ? 'online' : 'offline'}</td>
                                <td><a use:sanchor href={spath(`/nsd-server/${item.id}/service`)} data-tooltip="Servige ping">S</a></td>
                                <td class="text-end" class:text-success={item.apdex_service.apdex_score >= 0.9} class:text-warning={item.apdex_service.apdex_score >= 0.8 && item.apdex_service.apdex_score < 0.9} class:text-danger={item.apdex_service.apdex_score < 0.8}>{(item.apdex_service.apdex_score * 100).toFixed(2)} %</td>
                                <td class="text-end">
                                    <span class:text-success={item.last_service_ping_us < item.service_apdex_thresholds.satisfied_us} class:text-warning={item.last_service_ping_us >= item.service_apdex_thresholds.satisfied_us && item.last_service_ping_us < item.service_apdex_thresholds.tolerated_us} class:text-danger={item.last_service_ping_us >= item.service_apdex_thresholds.tolerated_us}>{humanizedNumber(item.last_service_ping_us, 2, 1000, ['µs', 'ms', 's'], false, $lg)}</span>
                                    @ <Date value={item.last_service_contact} format="h-table-s" />
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </div>
{/if}
